import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-cell-rank',
  templateUrl: './dashboard-cell-rank.component.html',
  styleUrls: ['./dashboard-cell-rank.component.css']
})
export class DashboardCellRankComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
